import {
  DELETE_SUBSCRIBER,
  DELETE_SUBSCRIBER_FAILURE,
  DELETE_SUBSCRIBER_SUCCESS,
  GET_SUBSCRIBERS,
  GET_SUBSCRIBERS_FAILURE,
  GET_SUBSCRIBERS_SUCCESS,
} from "./actionTypes";

export const getSubscribers = (payload) => {
  return {
    type: GET_SUBSCRIBERS,
    payload,
  };
};

export const getSubscribersSuccess = (payload) => {
  return {
    type: GET_SUBSCRIBERS_SUCCESS,
    payload,
  };
};

export const getSubscribersFailure = (payload) => {
  return {
    type: GET_SUBSCRIBERS_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const deleteSubscriber = (payload) => {
  return {
    type: DELETE_SUBSCRIBER,
    payload,
  };
};

export const deleteSubscriberSuccess = (payload) => {
  return {
    type: DELETE_SUBSCRIBER_SUCCESS,
    payload,
  };
};

export const deleteSubscriberFailure = (payload) => {
  return {
    type: DELETE_SUBSCRIBER_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================
